import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'which_of_the_following_topics_are_included_win_the_facs_written_4'

export const dataPointDefinition = {
  retracedId: 'which_of_the_following_topics_are_included_win_the_facs_written_4',
  name: "Which of the following topics are included within the facility's written policies and procedures for anti-discrimination?",
  description: '',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'NON_DISCRIMINATION_BASED_ON_RACE_ETHNIC_GROUP_SKIN_COLOR',
      text: 'Non-discrimination based on race / ethnic group / skin color',
      externalIds: [
        {
          id: 'ms-1--6-1x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NON_DISCRIMINATION_BASED_ON_SEX_GENDER',
      text: 'Non-discrimination based on sex / gender',
      externalIds: [
        {
          id: 'ms-1--6-2x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NON_DISCRIMINATION_BASED_ON_RELIGION',
      text: 'Non-discrimination based on religion',
      externalIds: [
        {
          id: 'ms-1--6-3x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NON_DISCRIMINATION_BASED_ON_POLITICAL_OPINION',
      text: 'Non-discrimination based on political opinion',
      externalIds: [
        {
          id: 'ms-1--6-4x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NON_DISCRIMINATION_BASED_ON_NATIONAL_EXTRACTION',
      text: 'Non-discrimination based on national extraction',
      externalIds: [
        {
          id: 'ms-1--6-5x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NON_DISCRIMINATION_BASED_ON_SOCIAL_ORIGIN',
      text: 'Non-discrimination based on social origin',
      externalIds: [
        {
          id: 'ms-1--6-6x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NON_DISCRIMINATION_BASED_ON_DISABILITY',
      text: 'Non-discrimination based on disability',
      externalIds: [
        {
          id: 'ms-1--6-7x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NON_DISCRIMINATION_BASED_ON_HIV_AIDS_STATUS_REAL_OR_PERCEIVED_',
      text: 'Non-discrimination based on HIV/AIDS status (real or perceived)',
      externalIds: [
        {
          id: 'ms-1--6-8x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NON_DISCRIMINATION_BASED_ON_SEXUAL_ORIENTATION',
      text: 'Non-discrimination based on sexual orientation',
      externalIds: [
        {
          id: 'ms-1--6-9x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NON_DISCRIMINATION_BASED_ON_PREGNANCY_MATERNITY_STATUS',
      text: 'Non-discrimination based on pregnancy/maternity status',
      externalIds: [
        {
          id: 'ms-1--6-10x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NON_DISCRIMINATION_BASED_ON_MARITAL_STATUS',
      text: 'Non-discrimination based on marital status',
      externalIds: [
        {
          id: 'ms-pla-17x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NON_DISCRIMINATION_BASED_ON_AGE',
      text: 'Non-discrimination based on age',
      externalIds: [
        {
          id: 'ms-1--6-11x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NON_DISCRIMINATION_BASED_ON_MEMBERSHIP_IN_WORKER_ORGANIZATIONS',
      text: 'Non-discrimination based on membership in worker organizations',
      externalIds: [
        {
          id: 'ms-1--6-12x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NON_DISCRIMINATION_BASED_ON_NATIONALITY_FOREIGN_MIGRANT_WORKER_',
      text: 'Non-discrimination based on Nationality/foreign migrant worker status',
      externalIds: [
        {
          id: 'ms-1--6-13x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NON_DISCRIMINATION_BASED_ON_FAMILY_RESPONSIBILITIES',
      text: 'Non-discrimination based on family responsibilities',
      externalIds: [
        {
          id: 'ms-pla-18x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NON_DISCRIMINATION_IN_RECRUITMENT_AND_HIRING',
      text: 'Non-discrimination in recruitment and hiring',
      externalIds: [
        {
          id: 'ms-1--6-14x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NON_DISCRIMINATION_IN_COMPENSATION_AND_PROMOTION',
      text: 'Non-discrimination in compensation and promotion',
      externalIds: [
        {
          id: 'ms-1--6-15x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NON_DISCRIMINATION_IN_WORKING_CONDITIONS',
      text: 'Non-discrimination in working conditions',
      externalIds: [
        {
          id: 'ms-1--6-16x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NON_DISCRIMINATION_IN_DISCIPLINE',
      text: 'Non-discrimination in discipline',
      externalIds: [
        {
          id: 'ms-1--6-17x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NON_DISCRIMINATION_IN_TERMINATION',
      text: 'Non-discrimination in termination',
      externalIds: [
        {
          id: 'ms-1--6-18x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'UNCONSCIOUS_BIAS',
      text: 'Unconscious bias',
      externalIds: [
        {
          id: 'ms-pla-19x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'OTHER',
      text: 'Other',
      externalIds: [
        {
          id: 'ms-1--6-19x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
      followUp: {
        fieldType: 'SHORT_TEXT',
        text: 'If other, please describe:',
        externalIds: [
          {
            id: 'ms-1--6-19f',
            version: '1.6.0',
            provider: 'slcp',
          },
        ],
      },
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'NON_DISCRIMINATION_BASED_ON_RACE_ETHNIC_GROUP_SKIN_COLOR',
                'NON_DISCRIMINATION_BASED_ON_SEX_GENDER',
                'NON_DISCRIMINATION_BASED_ON_RELIGION',
                'NON_DISCRIMINATION_BASED_ON_POLITICAL_OPINION',
                'NON_DISCRIMINATION_BASED_ON_NATIONAL_EXTRACTION',
                'NON_DISCRIMINATION_BASED_ON_SOCIAL_ORIGIN',
                'NON_DISCRIMINATION_BASED_ON_DISABILITY',
                'NON_DISCRIMINATION_BASED_ON_HIV_AIDS_STATUS_REAL_OR_PERCEIVED_',
                'NON_DISCRIMINATION_BASED_ON_SEXUAL_ORIENTATION',
                'NON_DISCRIMINATION_BASED_ON_PREGNANCY_MATERNITY_STATUS',
                'NON_DISCRIMINATION_BASED_ON_MARITAL_STATUS',
                'NON_DISCRIMINATION_BASED_ON_AGE',
                'NON_DISCRIMINATION_BASED_ON_MEMBERSHIP_IN_WORKER_ORGANIZATIONS',
                'NON_DISCRIMINATION_BASED_ON_NATIONALITY_FOREIGN_MIGRANT_WORKER_',
                'NON_DISCRIMINATION_BASED_ON_FAMILY_RESPONSIBILITIES',
                'NON_DISCRIMINATION_IN_RECRUITMENT_AND_HIRING',
                'NON_DISCRIMINATION_IN_COMPENSATION_AND_PROMOTION',
                'NON_DISCRIMINATION_IN_WORKING_CONDITIONS',
                'NON_DISCRIMINATION_IN_DISCIPLINE',
                'NON_DISCRIMINATION_IN_TERMINATION',
                'UNCONSCIOUS_BIAS',
                'OTHER',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'ms-pla-16',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 19070,
  sectionId: '2.2.6.10',
  impactArea: 'Policies and Procedures',
  impactAreaId: 'POLICIES_AND_PROCEDURES',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
